/** Token visio externe : `?guest=`, `/join/…`, et liens e-mail dont le `=` a été corrompu. */

const GUEST_TOKEN_RE = /^[a-f0-9]{32,64}$/i;

function looksLikeGuestToken(value: string): boolean {
  return GUEST_TOKEN_RE.test(value);
}

function tokenFromMangledBlob(blob: string): string | null {
  const cleaned = blob.replace(/%EF%BF%BD/gi, "\uFFFD");
  const m = cleaned.match(/^guest[\uFFFD=\s_\-./]*([a-f0-9]{32,64})$/i);
  return m && looksLikeGuestToken(m[1]) ? m[1] : null;
}

export function readGuestToken(): string | null {
  if (typeof window === "undefined") return null;

  try {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = (params.get("guest") || "").trim();
    if (looksLikeGuestToken(fromQuery)) return fromQuery;

    for (const [key, value] of params.entries()) {
      const recovered = tokenFromMangledBlob(`${key}${value}`);
      if (recovered) return recovered;
    }
  } catch {
    /* ignore */
  }

  const path = window.location.pathname.replace(/\/+$/, "");
  const pathMatch = path.match(/^\/(?:join|guest)\/([a-f0-9]{32,64})$/i);
  if (pathMatch && looksLikeGuestToken(pathMatch[1])) return pathMatch[1];

  try {
    const raw = window.location.search.replace(/^\?/, "");
    const recovered = tokenFromMangledBlob(raw);
    if (recovered) return recovered;
  } catch {
    /* ignore */
  }

  return null;
}

export function isChatGuestJoin(): boolean {
  return readGuestToken() != null;
}
